import { IDispatchSetStateAction } from "@Components/shared/types";
import SessionManager from "@Core/session";
import { ICommentDetails } from "@Models/IActivityDetails";
import ActivityService from "@Services/ActivityService";
import "@Styles/pages/activityPage.scss";
import { useEffect, useState } from "react";

export type CommentState = {
    submitting: boolean;
    value: string;
};

interface IProps {
    progress: number;
    duration: number;
    activityInstanceId: string;
    comments: ICommentDetails[];
    setComments: IDispatchSetStateAction<ICommentDetails[]>;
    onCommentsChanged: () => Promise<void>;
}

const VideoCommentHooks = (listElement, props: IProps) => {
    const [commentSubmissionState, setCommentSubmissionState] = useState<CommentState>({
        submitting: false,
        value: "",
    });

    const onDeletePreviousComment = async (item: ICommentDetails) => {
        const currentComments = [...props.comments];
        const i = currentComments.findIndex((commentItem) => commentItem.activityCommentId === item.activityCommentId);
        if (i > -1) {
            currentComments.splice(i, 1);
            const service = new ActivityService();
            await service.removeComment(item.activityCommentId);
            props.setComments(currentComments);
            props.onCommentsChanged();
        }
    };

    const onEditPreviousComment = async (value: string, item: ICommentDetails) => {
        if (value === "") return;
        const currentComments = [...props.comments];
        const i = currentComments.findIndex((commentItem) => commentItem.activityCommentId === item.activityCommentId);
        if (i > -1) {
            const editComment = { ...currentComments[i] };
            editComment.content = value;
            currentComments[i] = editComment;
            const service = new ActivityService();
            await service.updateComment(editComment);
            props.setComments(currentComments);
            props.onCommentsChanged();
        }
    };

    const onSubmitNewComment = async () => {
        if (!commentSubmissionState.value) {
            return;
        }
        setCommentSubmissionState({
            submitting: true,
            value: commentSubmissionState.value,
        });

        const commentItem: ICommentDetails = {
            activityInstanceId: props.activityInstanceId,
            time: Math.round(props.duration * props.progress * 10), // progress in milliseconds
            activityCommentId: "",
            userId: SessionManager.getServiceUser()?.userId,
            fullName: SessionManager.getServiceUser()?.fullName,
            dateTime: new Date()?.toISOString(),
            content: commentSubmissionState.value,
            parentActivityCommentId: "",
        };

        const service = new ActivityService();
        await service.addComment(commentItem);

        const currentComments = [...props.comments];
        currentComments.push(commentItem);
        props.setComments(currentComments);
        props.onCommentsChanged();

        setCommentSubmissionState({
            submitting: false,
            value: "",
        });
        updateDOM();
    };

    useEffect(() => {
        props.onCommentsChanged();
        updateDOM();
    }, [props.comments]);

    const updateDOM = () => {
        listElement.current.scrollTop = listElement.current.scrollHeight;
    };

    const onChange = (e) => {
        setCommentSubmissionState({ ...commentSubmissionState, value: e.target.value });
    };

    return {
        commentSubmissionState,
        onChange,
        onSubmitNewComment,
        onEditPreviousComment,
        onDeletePreviousComment,
    };
};
export default VideoCommentHooks;
